
import CropFreeIcon from '@mui/icons-material/CropFree';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WidgetsIcon from '@mui/icons-material/Widgets';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WarehouseIcon from '@mui/icons-material/Warehouse';

export const spWebshopCredentialsDetailsConfig = {
    details: {
        title: 'details',
        icon: <WidgetsIcon/>,
    },
    sync: {
        title: 'sync',
        icon: <WidgetsIcon/>,
    },
    spOrders: {
        title: 'sp_orders',
        icon: <FormatListBulletedIcon/>,
    },
    shippingOptions: {
        title: 'shipping_options',
        icon: <WidgetsIcon/>,
    },
};
